module.exports = __webpack_public_path__ + "static/media/withdraw.177dbbe0.jpg";